import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Calendar } from "@/pages/team/Calendar";

/** `?person=<userId>` zeigt nur Termine der Projekte, in denen diese Person besetzt ist (aus dem Chat, 03.09.2026). */
const suche = z.object({ person: z.string().trim().min(1).optional() }).catch({});

export const Route = createFileRoute("/_angemeldet/_mitarbeiter/kalender")({
	validateSearch: suche,
	component: KalenderRoute,
});

function KalenderRoute() {
	const { person } = Route.useSearch();
	return <Calendar person={person ?? null} />;
}
